import React, { useContext, useEffect, useState } from 'react';
import './UserPage.scss';
import PageHeader from '../PageHeader/PageHeader';
import { Tabs } from 'antd';
import PersonalInfo from '../PersonalInfo/PersonalInfo';
import './UserPage.scss';
import Appeal from '../Appeal/Appeal';
import AppealList from '../AppealList/AppealList';
import { Context } from '../../index';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

const { TabPane } = Tabs;

const UserPage = (): JSX.Element => {
  const { store } = useContext(Context);
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(store.currentTab);
  const handleTabChange = (key: string): void => {
    setActiveTab(key);
    store.setCurrentTab(key);
  };
  useEffect(() => {
    if (localStorage.getItem('refresh_token')) {
      store.checkAuth().then(() => {
        if (!store.isAuth) {
          history.push('/login');
        }
      });
    } else {
      history.push('/login');
    }
  }, []);

  useEffect(() => {
    if (activeTab !== store.currentTab) {
      setActiveTab(store.currentTab);
    }
  }, [store.currentTab]);

  if (!store.credentials.verified) {
    return (
      <>
        <div className="userPage">
          <PageHeader title="Личный кабинет" />
          <div className="userPage__content">
            <div className="registrationSucsess">
              <p>
                Вам необходимо подтвердить адрес электронной почты для
                продолжения работы.
              </p>
              <p>
                Ссылка для подтверждения отправлена на адрес электронной почты,
                указанный при регистрации.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {store.isAuth && store.credentials.verified ? (
        <div className="userPage">
          <PageHeader title="Личный кабинет" />
          <div className="userPage__content">
            <Tabs
              onChange={(key) => handleTabChange(key)}
              type="card"
              activeKey={activeTab}
            >
              <TabPane tab="Мои сообщения" key="1">
                {activeTab == '1' && <AppealList onlyUser={true} />}
              </TabPane>
              <TabPane tab="Сообщить о проблеме" key="2">
                {activeTab == '2' && <Appeal setActiveTab={setActiveTab} />}
              </TabPane>
              {store.isAdmin && (
                <TabPane tab="Сообщения в работе" key="3">
                  {activeTab == '3' && <AppealList onlyUser={false} />}
                </TabPane>
              )}
              <TabPane tab="Личные данные" key="4">
                <PersonalInfo />
              </TabPane>
            </Tabs>
          </div>
        </div>
      ) : (
        <LoaderSpinner />
      )}
    </>
  );
};

export default observer(UserPage);
